import React from "react";
import nl2br from "react-nl2br";

const WhatsappChatWindow = ({message}) => {
    return (
        <div className="whatsapp-chat-container">
            <div className="container">
                {(message.length > 0) && <div className="msg">
                    <div className="bubble altfollow">
                        <div className="txt">
                            {/*<span className="timestamp">10:21 pm</span>*/}
                            <p className="message follow">
                                {nl2br(message)}
                            </p>
                        </div>
                        <div className="bubble-arrow alt"/>
                    </div>
                </div>}
            </div>
        </div>
    );
}

export default WhatsappChatWindow;
